import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import { useParams } from 'react-router-dom';
import { QuizWrapper, QuizProps, RootineFooter } from '../components';
import { useGlobalState } from '../utils/GlobalStateProvider';
import { sendEvent } from '../utils';
import { ANALYTICS_EVENTS } from '../config';

export const Survey = () => {
  let { code } = useParams();
  const props: QuizProps = {
    quizCode: code || '',
    bypassModal: true,
  };
  const context = useGlobalState(true);
  const {
    state: { user },
  } = context;

  useEffect(() => {
    if (user && user.email && user.id) {
      sendEvent(ANALYTICS_EVENTS.benefits_quiz_started, {
        userEmail: user.email,
        userId: user.id,
      });
    }
  }, [user?.email, user?.id]);

  return (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      spacing={4}
      rowSpacing={2}
      sx={{
        px: { xs: 5, md: 10 },
        marginTop: { xs: 10, md: 10 },
      }}
    >
      <QuizWrapper {...props} />
      <Grid item>
        <RootineFooter />
      </Grid>
    </Grid>
  );
};
